import { render, staticRenderFns } from "./wtr-selection-dropdown.vue?vue&type=template&id=324fe0ef&scoped=true&"
import script from "./wtr-selection-dropdown.vue?vue&type=script&lang=js&"
export * from "./wtr-selection-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./wtr-selection-dropdown.vue?vue&type=style&index=0&id=324fe0ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324fe0ef",
  null
  
)

export default component.exports